import React, {createRef, useState} from 'react';
import {useAuth0} from "@auth0/auth0-react";
import MaterialTable from "@material-table/core";
import MaterialTableBody from "../../../controls/Material-Table-Components/MaterialTableBody";
import MaterialTableBodyRow from "../../../controls/Material-Table-Components/MaterialTableBodyRow";
import { Checkbox, useTheme } from "@material-ui/core";

import AirportLookup from "../../Airports/components/AirportsLookup";
//import { ColumnWidth } from "../../../blocks/ColumnHelper";
import { ComboSelect } from '../../../controls';

const ScheduledTripLegList = (_props) => {
  const theme = useTheme();
  const tableRef = createRef({state: {lastEditingRow: false}});
  const {isAuthenticated} = useAuth0();

  const props = {
    ..._props
  }
  
  const [state] = useState({
    canEdit: props.canEdit,
    activeRow: null
  });

  const tripLegs = props.tripRecord.legs;

  const getColumns = (props) => {
    const baseColumn = {
      cellStyle: { padding: "8px 2px" },
      headerStyle: { padding: "8px 2px" },
      editable: "never",
      emptyValue: "",
      initialEditValue: "",
      sorting: false
    };

    return [
      {
        ...baseColumn,
        title: "Origin",
        field: "originAirportCode",
        width: 70,
        maxWidth: 70,
        minWidth: 70,
        cellStyle: state.canEdit?{ width: 66, minWidth: 66, maxWidth: 66, padding: "8px 10px 8px 8px" }:{ width: 66, minWidth: 66, maxWidth: 66, padding: "8px 10px 8px 12px" },
        headerStyle: state.canEdit?{padding: "8px 2px" }:{padding: "8px 12px" },
        editComponent: (props) => (
          <AirportLookup
            value={props.value}
            onChange={props.onChange}
          />
        ),
      },
      {
        ...baseColumn,
        title: "Dest",
        field: "destinationAirportCode",
        width: 70,
        maxWidth: 70,
        minWidth: 70,
        cellStyle: state.canEdit?{ width: 66, minWidth: 66, maxWidth: 66, padding: "8px 2px" }:{ width: 66, minWidth: 66, maxWidth: 66, padding: "8px 12px" },
        headerStyle: state.canEdit?{padding: "8px 2px" }:{padding: "8px 12px" },
        editComponent: (props) => (
          <AirportLookup
            value={props.value}
            onChange={props.onChange}
          />
        ),
      },
      {
        ...baseColumn,
        title: "Alt",
        field: "alternateAirportCode",
        width: 70,
        maxWidth: 70,
        minWidth: 70,
        cellStyle: { width: 66, minWidth: 66, maxWidth: 66, padding: "8px 12px" },
        headerStyle: {padding: "8px 12px"},
      },
      {
        ...baseColumn,
        title: "Transport Type",
        field: "transportType",
        editable: "never",
        render: (rowData) => (
          <ComboSelect
            id="transportType"
            group="TRANSPORT TYPES"
            subGroup=""
            fullWidth
            value={`${rowData.transportType}`}
            displayOnly={true}
          />
        ),
      },
      {
        ...baseColumn,
        title: "Flight No",
        field: "flightNo",

        render: (props) => (
          <div style={{ width: 162 }}>
            {props.airlineCode}&nbsp;{props.flightNo}
          </div>
        ),
      },
      {
        ...baseColumn,
        title: "Offset",
        field: "offsetDay",
        type: "numeric",
        emptyValue: 0,
        defaultValue: 0,
      },
      {
        ...baseColumn,
        title: "Departure UTC",
        field: "scheduledDepartureTimeUTC",
        type: "time",
        emptyValue: 0,
        defaultValue: 0,
      },
      {
        ...baseColumn,
        title: "Arrival UTC",
        field: "scheduledArrivalTimeUTC",
        type: "time",
        emptyValue: 0,
        defaultValue: 0,
      },
      {
        ...baseColumn,
        title: "Leg Type",
        field: "legType",
        editable: "never",
        render: (rowData) => (
          <ComboSelect
            id="legType"
            group="TRIP LEG TYPES"
            subGroup=""
            fullWidth
            value={`${rowData.legType}`}
            displayOnly={true}
          />
        ),
      },
      {
        ...baseColumn,
        title: "Tech Stop",
        field: "techStop",
        type: "boolean",
        render: rowData =>
          <Checkbox
            style={{padding: 0}}
            checked={(rowData.techStop === 1 || rowData.techStop === true) ?? true}
            value="true"
            onChange={ checked => {props.onChange(checked)} }
          />
      },
      {
        ...baseColumn,
        title: "Loading Allowed",
        field: "allowLoading",
        type: "boolean",
        render: rowData => <Checkbox style={{padding: 0}}
                                     checked={(rowData.allowLoading === 1 || rowData.allowLoading === true) ?? true}
                                     value="true"
                                     onChange={ checked => {props.onChange(checked)} }
                            />
      },
      {
        ...baseColumn,
        title: "Through Allowed",
        field: "allowThroughCargo",
        type: "boolean",
        render: rowData => <Checkbox style={{padding: 0}}
                                     checked={(rowData.allowThroughCargo === 1 || rowData.allowThroughCargo === true) ?? true}
                                     value="true"
                                     onChange={ checked => {props.onChange(checked)} }
                            />
      },
    ];
  };
  
  return (isAuthenticated &&
      <div style={{ marginLeft: 50 }}>
        <MaterialTable
            tableRef={tableRef}
            data={tripLegs}
            style={{
              backgroundColor: "#fdfdfd",
              border: "2px solid #aaaaaa",
              boxShadow: "none",
              borderRadius: 0,
            }}
            options={{
              actionsColumnIndex: -1,
              search: false,
              cellStyle: {
                padding: "8px 2px",
              },
              headerStyle: {
                backgroundColor: theme.palette.childTableHeader.backgroundColor,
                color: theme.palette.childTableHeader.textColor,
                padding: "2px",
              },
              toolbarButtonAlignment: "right",
              detailPanelType: "single",
              paging: false
            }}
            components={{
              Body: MaterialTableBody,
              Row: MaterialTableBodyRow,
            }}
            title="Scheduled Trip Sectors"
            columns={getColumns({...props, canEdit: state.canEdit})}
            actions={[
            ]}

        />
      </div>
  );
}

export default ScheduledTripLegList;
